import { Chain, isTestnetPremiumOnly } from '@ankr.com/chains-list';
import { useEffect, useState } from 'react';

import { getInitialChainType } from 'modules/chains/utils/getInitialChainType';
import { isMainnetHidden } from 'modules/chains/utils/isMainnetHidden';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useSubchainID } from 'modules/chains/hooks/useSubchainID';

interface UseChainTypeProps {
  chain: Chain;
  shouldSkipChainTypeReset?: boolean;
}

export const useChainType = ({
  chain,
  shouldSkipChainTypeReset,
}: UseChainTypeProps) => {
  const subchainID = useSubchainID();

  const { isPremium } = useAccountStatus();

  const [chainType, setChainType] = useState(
    getInitialChainType({
      chain,
      isHiddenMainnet: isMainnetHidden(chain),
      isMainnetPremiumOnly: !isPremium && chain?.isMainnetPremiumOnly,
      isTestnetPremiumOnly: isTestnetPremiumOnly(chain),
      netId: subchainID,
    }),
  );

  useEffect(() => {
    if (shouldSkipChainTypeReset) {
      return () => {};
    }

    setChainType(
      getInitialChainType({
        chain,
        isHiddenMainnet: isMainnetHidden(chain),
        isMainnetPremiumOnly: !isPremium && chain?.isMainnetPremiumOnly,
        isTestnetPremiumOnly: isTestnetPremiumOnly(chain),
        netId: subchainID,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chain]);

  return { chainType, setChainType };
};
